import { prop } from 'ramda';
import { useMyAccountSidebarSelector } from '@core/js/store/hooks';

const useIsOpenSidebar = () => useMyAccountSidebarSelector(prop('isOpened'));

export default useIsOpenSidebar;
